import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModel } from './base';
export let EApiClientExternalSource;
(function (EApiClientExternalSource) {
  EApiClientExternalSource["Auth0"] = "auth0";
})(EApiClientExternalSource || (EApiClientExternalSource = {}));
export const fieldsApiClient = _extends({}, fieldsIBaseModel, {
  externalId: {
    type: 'Object'
  }
});